
<dialog [id]="'customizer-dialog-'+id"
        modal='true'
        (close)="dialogClose($event)">
    <button class="close"
            type="button"
            value="cancel"
            onclick="this.closest('dialog').close()"
            [attr.aria-label]="'CUSTOMIZER.VIEW_CLOSE' | translate">
        <app-svg use="close"></app-svg>
    </button>
    @if(response$(); as response) {
        @if(response.dialogHead; as dialogHead) {
            <header>
                <div class="product-title">{{ dialogHead.productName }}</div>
                <h2>{{ 'CUSTOMIZER.OPEN_FROM_OVERVIEW' | translate }}</h2>
                <div class="step">{{ 'CUSTOMIZER.VIEW_TITLE_PART3' | translate:{ currentStep:dialogHead.currentStep+1, totalSteps:dialogHead.totalSteps,} }}</div>
                <hr>
                <ul class="selected">
                    @for(selectedOption of dialogHead.overview; track $index) {
                        <li class="option">
                            <span class="option-title"
                            [attr.data]="selectedOption.variant">{{ selectedOption.title }}</span>
                            <span class="option-name">{{ selectedOption.variant }}</span>
                        </li>
                    }
                </ul>
                <h3>{{ 'CUSTOMIZER.VIEW_SECTION_TITLE' | translate:{currentStep:dialogHead.currentStep+1, viewTypeTitle:dialogHead?.typeTitle??''} }}</h3>
            </header>
        }
        <!-- @if(response.dialogFilters; as filters) {
            <form [id]="'customizer-dialog-filter-'+id"
                  (change)="filterChanged()">
                @for(filter of filters; track $index) {
                    <ul class="filter"
                        [attr.aria-label]="'CUSTOMIZER.VIEW_FILTER_TITLE' | translate:{filterTitle:filter?.title}">
                        @for(facet of filter?.facets; track facet.id) {
                            <li >
                                <input type="checkbox"
                                [attr.name]="'customizer-filter-'+facet?.id"
                                [attr.value]="facet?.id"
                                [attr.depth]="facet?.depth"
                                [attr.id]="'customizer-dialog-'+facet?.id">
                                <label [attr.for]="facet?.id">{{ facet?.title }}</label>
                            </li>
                        }
                    </ul>
                }
            </form>
        } -->
        @if(response.dialogView; as view) {
            <form [id]="'customizer-dialog-form-'+id"
                [class]="view.mode">
                <ul class="option-group-list">
                    @for(group of view?.groups; track group.id) {
                        <li class="option-group"
                            filter-level="1"
                            [attr.hidden]="group.hidden ? '' : null">
                            <h4>{{ group?.name }}</h4>
                            <div [innerHTML]="group?.description"></div>
                            <ul class="translated-specifications">
                                @for(translatedSpecifications of group?.translatedSpecifications; track translatedSpecifications) {
                                    <li > {{ translatedSpecifications }}</li>
                                }
                            </ul>
                            <ul class="option-list">
                                @for(variant of group?.variants; track variant.variation) {
                                    <!-- <pre>{{ variant | json }}</pre> -->
                                    <li class="option"
                                        filter-level="2"
                                        [attr.hidden]="variant?.hidden ? '' : null">
                                    <label>
                                        <img [use]="variant?.imageUrl"
                                            [query]="{ width: 52, height:52,  }"
                                            role="presentation"
                                            height="52"
                                            width="52">
                                        <span class="option-name">{{ variant?.name }}</span>
                                        <span class="option-price">{{ variant?.low?.salesPrice | price }} {{ vatTranslationKey | translate }}</span>
                                        <!-- <span class="option-description">{{ option?.description }}</span>
                                        <span class="option-variation">{{ option?.variation }}</span> -->
                                        <input type="radio"
                                            [attr.name]="view?.productType"
                                            [attr.checked]="variant?.selected ? '' : null"
                                            [id]="'customizer-dialog-'+group?.id+'--'+variant?.low?.variation"
                                            (input)="changed(view.productId, variant?.low?.variation)"
                                            [value]="variant?.low?.variation">
                                        </label>
                                    </li>
                                }
                            </ul>
                        </li>
                    }
                </ul>
                <menu>
                    <hr>
                    <button type="button"
                            class="previous"
                            value="cancel"
                            (click)="goTo(view.previous)">
                        <span>{{ 'CUSTOMIZER.VIEW_NAVIGATE_TO_PREVIOUS' | translate }}</span>
                    </button>
                    <button type="button"
                            [attr.formmethod]="view.atEnd ? null :'dialog'"
                            class="next"
                            (click)="goTo(view.next)">
                        <span>{{ (view.atEnd ? 'CUSTOMIZER.VIEW_NAVIGATE_TO_END' : 'CUSTOMIZER.VIEW_NAVIGATE_TO_NEXT') | translate }}</span>
                    </button>
                </menu>
            </form>
        }
    }
</dialog>
